"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("util");
var index_1 = require("../../index");
function jsonToQueryString(json) {
    return Object.keys(json).filter(function (key) { return json[key] !== undefined; }).map(function (key) {
        if (util_1.isArray(json[key])) {
            return encodeURIComponent(key) + '=' + JSON.stringify(json[key]);
        }
        else {
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
        }
    }).join('&');
}
exports.ProductAPI = {
    getProducts: function (companyId, searchFilters) {
        var url = "/api/v1/company/" + companyId + "/products?";
        if (searchFilters) {
            url += jsonToQueryString(searchFilters);
        }
        return index_1.axios.get(url).then(function (response) {
            var products = response.data;
            return products;
        });
    },
    getDuplicatesSkuAndBarcode: function (companyId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/api/v1/company/" + companyId + "/products/duplicateProducts";
                        return [4 /*yield*/, index_1.axios.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    },
    getProvinceProducts: function (companyId, province, searchFilters) {
        var url = "/api/v1/company/" + companyId + "/provinceProducts/" + province;
        return index_1.axios.get(url, {
            params: __assign({}, searchFilters)
        }).then(function (response) {
            var provinceProducts = response.data.products;
            return provinceProducts;
        });
    },
    getByProductSearch: function (companyId, searchFilters) {
        var url = "/api/v1/company/" + companyId + "/products/search";
        return index_1.axios.get(url, {
            params: searchFilters
        }).then(function (response) {
            var products = response.data.data;
            return products;
        });
    },
    getFlatProducts: function (companyId, searchFilters) {
        var url = "/api/v1/company/" + companyId + "/products/flat?";
        if (searchFilters) {
            url += jsonToQueryString(searchFilters);
        }
        return index_1.axios.get(url).then(function (response) {
            var products = response.data.data;
            return products;
        });
    },
    getInventoryProducts: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/inventory/products").then(function (response) {
            var inventoryProducts = response.data.products;
            return inventoryProducts;
        });
    },
    getProductById: function (companyId, productId, includeDeleted) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/product/" + productId, {
            params: { includeDeleted: includeDeleted }
        }).then(function (response) {
            var product = response.data;
            return product;
        });
    },
    addProduct: function (companyId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/products", createObject).then(function (response) {
            var product = response.data;
            return product;
        });
    },
    updateProduct: function (companyId, productId, updateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/products/" + productId, updateObject).then(function (response) {
            var product = response.data;
            return product;
        });
    },
    deleteProduct: function (companyId, productId) {
        return index_1.axios.delete("/api/v1/company/" + companyId + "/product/" + productId).then(function (response) {
            var product = response.data;
            return product;
        });
    },
    splitProduct: function (companyId, productId, name) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/product/" + productId + "/split", {
            params: { name: name }
        }).then(function (response) {
            var product = response.data; // returns the new standalone product
            return product;
        });
    },
    splitProductToVariant: function (companyId, productId, name) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/product/" + productId + "/splitToVariant", {
            params: { name: name }
        }).then(function (response) {
            var product = response.data; // returns the new standalone product
            return product;
        });
    },
    mergeProduct: function (companyId, sourceProductId, targetProductId) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/product/" + sourceProductId + "/merge/" + targetProductId).then(function (response) {
            var product = response.data; // returns the new standalone product
            return product;
        });
    },
    getCategories: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/categories").then(function (response) {
            var categories = response.data.categories;
            return categories;
        });
    },
    getComplianceCategories: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/categories/complianceCategories").then(function (response) {
            var complianceCategories = response.data.data;
            return complianceCategories;
        });
    },
    addCategory: function (companyId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/categories", createObject).then(function (response) {
            var category = response.data;
            return category;
        });
    },
    updateCategory: function (companyId, categoryId, createObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/category/" + categoryId, createObject).then(function (response) {
            var category = response.data;
            return category;
        });
    },
    updateCategories: function (companyId, updateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/categories", updateObject).then(function (response) { return response.data; });
    },
    updateCategoryOrder: function (companyId, ordering) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/categories/order", {
            order: ordering
        }).then(function (response) {
            var category = response.data;
            return category;
        });
    },
    deleteCategory: function (companyId, categoryId, newCategoryId) {
        return index_1.axios.delete("/api/v1/company/" + companyId + "/category/" + categoryId, {
            params: {
                newCategoryId: newCategoryId
            }
        }).then(function (response) {
            var category = response.data;
            return category;
        });
    },
    mergeCategory: function (companyId, categoryId, newParentCategoryId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/category/" + categoryId + "/merge", {
            newParentCategoryId: newParentCategoryId
        }).then(function (response) {
            var category = response.data;
            return category;
        });
    },
    getTaxGroups: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/taxGroups").then(function (response) {
            var taxGroups = response.data.taxGroups;
            return taxGroups;
        });
    },
    addTaxGroup: function (companyId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/taxGroup", createObject)
            .then(function (response) {
            return response.data;
        });
    },
    updateTaxGroup: function (companyId, taxGroupId, updateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/taxGroup/" + taxGroupId, updateObject)
            .then(function (response) {
            return response.data;
        });
    },
    deleteTaxGroup: function (companyId, taxGroupId) {
        return index_1.axios.delete("/api/v1/company/" + companyId + "/taxGroup/" + taxGroupId)
            .then(function (response) {
            return response.data;
        });
    },
    /**
     * @deprecated since v2
     */
    getDiscounts: function (companyId, searchFilter) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/discount", {
                        params: searchFilter
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.discounts];
            }
        });
    }); },
    getPaginatedDiscounts: function (companyId, searchFilter) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.get("/api/v2/company/" + companyId + "/discounts", {
                        params: searchFilter
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    /**
     * @deprecated please use v2
     */
    getDiscountById: function (companyId, discountId) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/discount/" + discountId)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    /**
     * @deprecated please use v2
     */
    addDiscount: function (companyId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/discount", createObject).then(function (response) {
            return response.data;
        });
    },
    /**
     * @deprecated please use v2
     */
    updateDiscount: function (companyId, discountId, updateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/discount/" + discountId, updateObject).then(function (response) {
            var discount = response.data;
            return discount;
        });
    },
    deleteDiscount: function (companyId, discountId) {
        return index_1.axios.delete("/api/v1/company/" + companyId + "/discount/" + discountId).then(function (response) {
            var discount = response.data;
            return discount;
        });
    },
    getAvailableBatches: function (companyId, locationId, productId, excludeClosed) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/location/" + locationId + "/inventory/products/" + productId + "/batches", {
            params: { excludeClosed: excludeClosed }
        }).then(function (response) {
            var batches = response.data;
            return batches;
        });
    },
    updateBatchById: function (companyId, locationId, productId, batchId, updateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/location/" + locationId + "/inventory/products/" + productId + "/batches/" + batchId, updateObject).then(function (response) {
            var batches = response.data;
            return batches;
        });
    }
};
//# sourceMappingURL=ProductAPI.js.map